import { ComputerCommandMenuNewBadge } from '#pplx/frontend/apps/ask/composer-sdk-plugins/skills-and-commands/ComputerCommandMenuNewBadge.js';
import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
function getMenuSection(type, commandItemsFirst) {
    switch (type) {
        case 'featured':
            // Exact-command results combine featured and custom skills.
            return commandItemsFirst ? 'skill' : 'featured';
        case 'plugin':
        case 'skill':
        case 'command':
            return type;
        default:
            return assertUnreachableValue(type);
    }
}
export function toTypeaheadGroups({ orderedItems, commandItemsFirst, resolvedSearchQuery, sectionTitles, }) {
    const groups = [];
    for (const item of orderedItems) {
        const section = getMenuSection(item.type, commandItemsFirst);
        const row = toTypeaheadItem({ item, resolvedSearchQuery });
        const previousGroup = groups.at(-1);
        if (previousGroup?.id === section) {
            previousGroup.items.push(row);
            continue;
        }
        groups.push({
            id: section,
            ...(section === 'featured' ? {} : { title: sectionTitles[section] }),
            items: [row],
        });
    }
    return groups;
}
export function toTypeaheadItem({ item, resolvedSearchQuery, }) {
    return {
        id: `${item.type}:${item.id}`,
        label: item.title,
        ...(resolvedSearchQuery ? { highlightQuery: resolvedSearchQuery } : {}),
        icon: item.action.type === 'connector'
            ? { type: 'source', sourceId: item.action.source.id }
            : { type: 'icon', icon: item.icon },
        ...(item.disabled ? { disabled: true } : {}),
        ...(item.isNew ? { trailingAccessory: ComputerCommandMenuNewBadge } : {}),
        payload: item,
    };
}
//# sourceMappingURL=computerMenuTypeaheadItems.js.map